<template>
  <kst-page-list
    :catalog="RecSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :warehouseOptions="warehouseOptions"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data }">
      <List
        :access="access"
        :dataList="data.List"
        :isAllWarehouse="isAllWarehouse"
      />
    </template>
  </kst-page-list>
</template>

<script>
import Model from "../RecModel.js";
import RecSearchCatalog from "../RecSearchCatalog.js";
import Services from "../../../services/Api/RecServices.js";

import List from "./RecL_List.vue";
import Search from "./RecL_Search.vue";

export default {
  components: {
    List,
    Search
  },
  data: () => ({
    Model: Model,
    RecSearchCatalog: RecSearchCatalog,
    access: {},
    isAllWarehouse: true,
    searchData: {
      Search: "",
      Client: "",
      ClientID: null, 
      InvoiceDate: null,
      Status: null,
      WarehouseID: null
    },
    warehouseOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadListData) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getListData(options); 
      loadListData(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.isAllWarehouse =
        this.$kst.Search.getValue(this.searchData.WarehouseID, null) === null;

      if (this.searchData.ClientID !== null) {
        this.searchData.Client = this.$kst.In.getString(data.Search.Client);
      }

      this.warehouseOptions = Model.getWarehouseOptions(
        data.WarehouseList, RecSearchCatalog.WarehouseID.Label
      );
    },

    handleLoad(loadList) {
      this.isAllWarehouse =
        this.$kst.Search.getValue(this.searchData.WarehouseID, null) === null;

      const options = this.getListOptions();
      const config = Services.getList(options);
      loadList(config);
    },

    handleReset() {
      this.resetSearch();
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.warehouseOptions = {};

      this.resetData_search();
    },
    resetData_search() {
      if (this.searchData.WarehouseID === null) {
        this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      }
    },

    resetSearch() {
      this.searchData.Search = "";
      this.searchData.Client = "";
      this.searchData.ClientID = null;
      this.searchData.InvoiceDate = this.$kst.In.getDefaultDateRange();
      this.searchData.Status = this.$kst.Search.OptionAll;
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },

    getListOptions() {
      const clientId = this.$kst.Out.getInteger(this.searchData.ClientID);
      const clientName = clientId === null
        ? this.$kst.Out.getString(this.searchData.Client) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.InvoiceDate[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.InvoiceDate[1]),
        client: clientId,
        clientname: clientName,
        status: this.$kst.Search.getValue(this.searchData.Status),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields
      };
    }
  }
}
</script>